module.exports = __webpack_public_path__ + "static/media/banner-loader.bf0b2951.gif";